import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_442tb6k986: FaireBrandEntity = {
  token: "b_442tb6k986",
  type: "brand",
  name: "Furbish Studio",
  avatarUrl:
    "https://cdn.faire.com/fastly/2012f57bb7999ce84dce0464e01d2ba5429a6b5d896a814a955211e1b1f86f98.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/acb8529c1445da9520dd4e36799fcef312b6ace1dafb48a66b59b54e8c275c5a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2012f57bb7999ce84dce0464e01d2ba5429a6b5d896a814a955211e1b1f86f98.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/acb8529c1445da9520dd4e36799fcef312b6ace1dafb48a66b59b54e8c275c5a.jpeg",
  location: "Raleigh, NC, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 178,
  isTopShop: true,
  isInsider: true,
  description:
    "Bold and bright, quirky and chic - Furbish’s line of vibrant home accessories is designed to make a statement.  Eye-catching patterns pair with kooky color combos to create a look that is one-of-a-kind.  Bridging traditional southern motifs with age-old art and handicrafts from around the world, Founder Jamie Meares is drawn to a dare-to-mix that’s all her own.  You can count on Furbish to appeal to the discerning decorator who’s not afraid to mix and match.  Charming accents that your friends are bound to ask “where’d you get that?”...bet it’s from Furbish.\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:49.361Z",
    importedBy: "entity-db-cli",
  },
};
